import { api } from './api-client';
import type { PlatformStats } from '@residenone/shared';

export type { PlatformStats };

export async function getPlatformStats(): Promise<PlatformStats> {
  const { data } = await api.get<PlatformStats>('/platform/stats');
  return data;
}
